<template>
  <sweet-modal ref="modal-publish" width="45vw" hide-close-button blocking>
    <section>
      <h1 class="mt-4">{{ $t('ct-publish-website-confirm')}} </h1>
      <h2 class="mt-4">{{ $t('ct-publish-website-really')}}</h2>

      <div class="card p-2 my-4 d-flex flex-column">
        <p class="flex-1 mt-3 mx-3 link-text">{{ website.title }}</p>
        <span
          class="mx-3 mb-3 title sub-title"
        >{{ getUrl() }}</span>
      </div>

      <div class="container-recaptch" v-if="captchaActive">
        <template v-if="captchaActive">
          <vue-recaptcha-cheetah
            sitekey="6LdTSfkUAAAAAKerT6RF8G2fmHVk6i6gtd9FI9nF"
            ref="recaptcha" @render="onCaptchRender"
            @verify="onCaptchaVerified"
            @expired="onCaptchaExpired">
          </vue-recaptcha-cheetah>
        </template>
        <p
          v-if="!captchaVerified"
          class="invalid-feedback"
          :class="{'d-block': !captchaVerified}"
          v-text="$t('ct-captcha-complete-please')"
        ></p>
      </div>
    </section>

    <button
      slot="button"
      class="btn btn-outline-light"
      @click.prevent="close()"
    >{{ $t('ct-cancel')}}</button>

    <button
      slot="button"
      class="btn btn-success"
      @click.prevent="publish"
    >{{ $t('ct-save')}}</button>
  </sweet-modal>
</template>

<script>
import {SweetModal} from 'sweet-modal-vue';
import {mapGetters} from 'vuex';
import {
  publish as PublishWebsiteRequest,
  publishWithoutDomain as publishWithoutDomainRequest, publishWithoutDomainCaptcha,
  updateVersion
} from '../../../../js/services/editor/publish';
import {updateStatus} from '../../../../js/services/editor/website';

export default {
  components: {SweetModal},
  name: 'SitePublish',
  props: ['website', 'show'],

  data() {
    return {
      captchaActive: false,
      captchaVerified: false,
      captchaShow: false,
    };
  },

  watch: {
    show: function(value) {
      if (value) this.open();
      else this.$refs['modal-publish'].close();
    }
  },

  methods: {
    ...mapGetters({ getUser: 'user' }),

    open() {
      this.publish();
    },

    close() {
      this.onCaptchaExpired();
      this.$refs['modal-publish'].close();
    },

    getUrl() {
      let user = this.getUser();
      return this.$getUrlWebsite(this.website, user);
    },

    onCaptchaVerified(response) {
      if (response) {
        this.captchaVerified = response;
      }
    },

    onCaptchaExpired() {
      this.captchaVerified = false;
      this.captchaShow = false;
      this.$refs.recaptcha.reset();
    },

    onCaptchRender() {},

    async updateStatus() {
      this.$loading.show();

      await updateStatus({
        encrypted_id: this.website.encrypted_id,
        status: 'active'
      })
        .then(res => {
          this.$emit('updateWebsites');
          this.$emit('openSaveTour');
        })
        .catch(() => {
          this.close();
          this.$snotify.error(
            'Something happened when trying to unpublish or publish your website, check the settings'
          );
        })
        .finally(() => {
          this.$loading.hide();
        });
    },

    republishAction(encryptedId) {
      this.$loading.show();

      updateVersion(encryptedId)
        .finally(() => this.$loading.hide())
        .then(res => {
          this.$emit('openSaveTour');
          this.$emit('updateWebsites');
        })
        .catch((error) => {
          if (error.response) {
            // Request made and server responded
            if (error.response.status === 429) { // to many
              this.$snotify.error(this.$t('ct-too-many-attempts'));
            }
            if (error.response.status === 401) {  // to many
              const message = (error.response && error.response.data && error.response.data.message) ? error.response.data.message : 'ct-plan-limited'
              this.$snotify.error(this.$t(message));
              setTimeout( () => {
                 this.$router.push({
                  name: 'Domain',
                  params: {
                    id: encryptedId
                  }
                });
              }, 2000 )
            }
          }
        });
    },

    publishWithoutDomainCaptcha() {
      this.$loading.show();

      publishWithoutDomainCaptcha(this.website.encrypted_id, this.captchaVerified)
        .then((res) => {
          this.close();
          this.updateStatus();
        })
        .catch((error) => {
          this.$loading.hide();
          if (error.response && error.response.status === 429) { // Too Many Attempts
            this.$snotify.error(this.$t('ct-too-many-attempts'));
          } else if (error.response.status === 401) {  // to many
              this.$snotify.error(this.$t('ct-plan-limited'));
              setTimeout( () => {
                 this.$router.push({
                  name: 'Domain',
                  params: {
                    id: encryptedId
                  }
                });
              }, 2000 )
            } else {
            this.$snotify.error(this.$t('ct-publish-error'));
          }
        })
        .finally(() => {
          this.onCaptchaExpired();
        });
    },

    publishWithoutDomain(encryptedId) {
      if (this.captchaActive) {
        console.log('captch ativo');
        if (this.captchaVerified) {
          console.log('captch validado');
          this.publishWithoutDomainCaptcha();
        } else { this.$refs['modal-publish'].open() }
      } else {
        this.$loading.show();

        publishWithoutDomainRequest(encryptedId)
          .then(() => {
            this.updateStatus();
          })
          .catch((error) => {
            this.$loading.hide();

          if (error.response && error.response.status === 429) { // Too Many Attempts
            this.$snotify.error(this.$t('ct-too-many-attempts'));
          } else if (error.response.status === 401) {  // to many
              this.$snotify.error(this.$t('ct-plan-limited'));
              setTimeout( () => {
                 this.$router.push({
                  name: 'Domain',
                  params: {
                    id: encryptedId
                  }
                });
              }, 2000 )
            } else {
            this.$snotify.error(this.$t('ct-publish-error'));
          }
          })
          .finally(() => {});
      }
    },

    publishWithDomain(encryptedId) {
      this.$loading.disabledPaceJs();

      PublishWebsiteRequest(encryptedId)
        .then(res => {
          console.log('publish website ->', res);
        })
        .catch(error => {
          console.warn(error);
        });

      this.updateStatus();
    },

    /**
     *  Publicar website
     */
    publish() {
      let encryptedId = this.website.encrypted_id;

      if (this.captchaActive && this.captchaShow && !this.captchaVerified) { return }

      /*
      *  Republish website
      * */
      if (this.website.status === 'active') {
        this.republishAction(encryptedId);
      } else if (this.website.status === 'inactive') {
        /*
        *  publish website
        * */
        if (this.website.dominio) {
          this.publishWithDomain(encryptedId);
        } else {
          this.publishWithoutDomain(encryptedId);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .sweet-buttons, .sweet-content-content{
    // font-family: Muli;
  }

  section{
    h1{
      font-weight: bold;
      font-size: 20px;
      font-family: Muli;
      color: #434343;
    }

    h2{
      color: #5A5959;
      font-family: Muli;
      font-size: 18px;
    }

    .link-text{
      font-size: 20px;
      color: #434343;
    }

    .container-recaptch{
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      p{
        text-align: center;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/dashboard/layout/site/SitePublish.vue